var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowWithTail = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m5.33 16-.35-.35-.36.35.36.35zm20 .5a.5.5 0 1 0 0-1zM12.98 7.65l-8 8 .7.7 8-8zm-8 8.7 8 8 .7-.7-8-8zm.35.15h20v-1h-20z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowWithTail);
export default ForwardRef;